import React, { useEffect } from "react";
import Highlights from "./Highlights";
import Search from "./Search";
import { useLocation, NavLink, Link } from "react-router-dom";

const Header = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div>
      {/* ================= TOP HEADER ================= */}
      <div className="topheader">
        <div className="topheaderbtn">
          <ul>
            <li>
              <Link to="https://entab.online/R-CRMLSD">Admission 2027-28</Link>
            </li>

            <li>
              <Link to="https://entab.online/CRMLSD">Parent Portal</Link>
            </li>

            <li>
              <Link to="/events">Event Calendar</Link>
            </li>

            <li>
              <Link to="/fee">FEES structure</Link>
            </li>
          </ul>
        </div>
      </div>

      {/* ================= MIDDLE HEADER ================= */}
      <div className="row">
        <div className="col-lg-3">
          <div className="midheaderleft">
            <Link to="/">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/logo.png"
                className="img-fluid"
                alt="School Logo"
              />
            </Link>
          </div>
        </div>

        <div className="col-lg-9">
          {/* <div className="col-lg-12">
            <Highlights />
          </div> */}

          <div className="col-lg-12">
            <div className="paymentsearch">
              <div className="search">
                <Search />
              </div>

              <div className="scan">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/scanimg.png"
                  className="img-fluid"
                  alt="Admission Open for 2026-27"
                />
                <a
                  href="https://entab.online/R-CRMLSD"
                  style={{ fontSize: "15px" }}
                >
                  Admission Open for 2026-27
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= NAVBAR ================= */}
      <div className="navheader">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            {/* Mobile Toggle */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#main_nav"
              aria-controls="main_nav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="bi bi-list-ul text-white"></i>
            </button>

            {/* Navbar Menu */}
            <div
              className="collapse navbar-collapse justify-content-center"
              id="main_nav"
            >
              <ul className="navbar-nav align-items-lg-center">
                {/* ================= HOME ================= */}
                <li className="nav-item">
                  <NavLink className="nav-link" to="/">
                    <i className="bi bi-house-door-fill"></i>
                  </NavLink>
                </li>

                {/* ================= ABOUT US ================= */}
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    About Us
                  </button>

                  <ul className="dropdown-menu">
                    <li>
                      <NavLink className="dropdown-item" to="/about">
                        About School
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/aim">
                        Aim
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/vision">
                        Vision & Mission
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/emblem">
                        Emblem & Motto
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/patroness">
                        Our Patroness
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/uniform">
                        School Uniform
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* ================= EVENT CALENDAR ================= */}
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Event Calendar
                  </button>

                  <ul className="dropdown-menu">
                    <li>
                      <NavLink className="dropdown-item" to="/events">
                        Events
                      </NavLink>
                    </li>

                    {/* <li>
                      <NavLink className="dropdown-item" to="/Academiccal">
                        Academic Calendar
                      </NavLink>
                    </li> */}
                  </ul>
                </li>

                {/* ================= ACADEMICS ================= */}
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Academics
                  </button>

                  <ul className="dropdown-menu">
                    <li>
                      <NavLink className="dropdown-item" to="/tc">
                        TC
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/affiliation">
                        School Rules
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/fee">
                        Fee Structure
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/withdrawal">
                        Admission & Withdrawal
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/admission">
                        Admission Open
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/absence">
                        Absence
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/promotion">
                        Examination & Promotion
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/faculty">
                        Faculty
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/privacy">
                        Privacy Policy
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* ================= FACILITIES ================= */}
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Facilities
                  </button>

                  <ul className="dropdown-menu">
                    <li>
                      <NavLink className="dropdown-item" to="/library">
                        Library
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/facilities">
                        Facilities
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/sports">
                        Sports Corner
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* ================= GALLERY ================= */}
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Gallery
                  </button>

                  <ul className="dropdown-menu">
                    <li>
                      <NavLink className="dropdown-item" to="/photo-gallery">
                        Photo Gallery
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/video-gallery">
                        Video Gallery
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* ================= CONTACT ================= */}
                <li className="nav-item">
                  <NavLink className="nav-link" to="/contact">
                    Contact
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
